export interface VisibilityConfigDef {
    a: number
    /*
    * visibility Flag
    * 0: hide nothing (show everything)
    * 1: hide itself
    * 2: hide lone pairs
    * 3: force text rendering (disable paper carbon UI)
    * 4: force text rendering AND hide lone pairs
    */

    visibilityFlag: VisibilityFlag,
}

export enum VisibilityFlag {
    Visible = 0,
    Hidden = 1,
    HiddenLP = 2,
    ForceText = 3,
    ForceTextHiddenLP = 4
}

export const visibilityDef = {
    encode: (visDef: VisibilityConfigDef) => {
        return `${visDef.a}:${visDef.visibilityFlag}`;
    },

    decode: (visibilityRep: string) => {
        const components = visibilityRep.split(":");
        if (components.length === 2) {
            return {
                a: parseInt(components[0]),
                visibilityFlag: parseInt(components[1]),
            } as VisibilityConfigDef;
        }
        return null;
    }
}